<mat-dialog-content *ngIf="!isLoading() && (getOperationStatus() == null)">
  <div class="title">
    <div class="title-icon">
        <i class="fas fa-file m-r-10"></i>
    </div>
    <h2>Atenção! Arquivo com senha</h2>
  </div>
  <div class="body-text">
    <p>
        O arquivo com o seu informe de rendimentos possui uma senha que corresponde aos 6 primeiros dígitos do seu {{getDocumentType()}}.
    </p>
    <div class="body-text-example">
        <span class="ex-txt">
            Exemplo
        </span>
        <span>
            {{getDocumentType()}}: {{getDocumentExample()}}
        </span>
        <span>
            Senha: 123456
        </span>
    </div>
  </div>
  <div class="quarter-alert" *ngIf="getDocumentType() == 'CNPJ'">
    <span>
        Documentos divididos por trimestre (3 meses)
    </span>
    <p>
        Os arquivos para empresas estão separados em quatro partes do ano. Ao clicar em "Baixar", você pega todos de uma vez.
    </p>
  </div>
</mat-dialog-content>
<div class="button-wrapper" *ngIf="!isLoading() && (getOperationStatus() == null)">
    <div class="btn cancel-btn" style="font-weight: bold;" (click)="dialogRef.close()">
     Cancelar
    </div>

    <div class="btn confirm-btn" style="font-weight: bold;" (click)="downloadIR()">
        {{ getButtonTextIR() }}
    </div>
</div>

<mat-dialog-content *ngIf="isLoading()">
    <div class="loading-wrapper">
        <div class="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
        <span>Baixando Informe de Rendimentos...</span>
    </div>
</mat-dialog-content>

<mat-dialog-content *ngIf="!isLoading() && (getOperationStatus() != null)">
    <div class="result-wrapper">
        <i fxLayoutAlign="center center" [ngClass]="{'fa fa-times-circle error-icon': getOperationStatus() == false, 'fas fa-check-circle success-icon': getOperationStatus() == true}"></i>
        <span>{{getOperationMessage()}}</span>
    </div>
</mat-dialog-content>
<div class="button-wrapper-result" *ngIf="!isLoading() && (getOperationStatus() != null)">
    <div class="btn" style="font-weight: bold;" (click)="dialogRef.close()">
     Fechar
    </div>
</div>

